import { useMutation, useQueryClient } from '@tanstack/react-query';

import {
    useAvApi,
} from '@app-velocity/av-api-v2';

export const useDeleteScenarioMutation = (workspaceId?: string) => {
    const { prototypes } = useAvApi();
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: ['delete-scenario-mutation'],
        mutationFn: async (scenarioId: string) => {
            if (!workspaceId || !scenarioId) return;

            const res = await prototypes.deleteV2ProjectsPrototypesByProjectIdAndPrototypeId({
                projectId: workspaceId,
                prototypeId: scenarioId
            });

            return res.data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: ['workspace-prototypes', workspaceId]
            })
        }
    });
};
